import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const UIPageHeader = ({
  title,
  subtitle,
  actions,
  children,
  sx,
  dense = false,
  overline,
}) => {
  return (
    <Box
      sx={{
        mb: dense ? 1.25 : 3,
        ...sx,
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="space-between"
        spacing={dense ? 1 : 2}
      >
        <Box>
          {overline ? (
            <Typography
              variant="overline"
              color="text.secondary"
              sx={{ display: "block", mb: dense ? 0.1 : 0.25, letterSpacing: "0.08em", fontSize: dense ? 11 : undefined }}
            >
              {overline}
            </Typography>
          ) : null}
          <Typography variant={dense ? "h5" : "h4"} color="text.primary" sx={dense ? { fontSize: { xs: 24, md: 28 }, lineHeight: 1.15 } : undefined}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: dense ? 0.35 : 0.75, maxWidth: dense ? 680 : "none", fontSize: dense ? 13 : undefined, lineHeight: dense ? 1.45 : undefined }}
            >
              {subtitle}
            </Typography>
          ) : null}
        </Box>
        {actions ? (
          <Stack direction="row" spacing={dense ? 0.75 : 1.5} flexWrap="wrap" useFlexGap>
            {actions}
          </Stack>
        ) : null}
      </Stack>
      {children ? <Box sx={{ mt: dense ? 1 : 2 }}>{children}</Box> : null}
    </Box>
  );
};

export default UIPageHeader;
